<template>
  <div>
    <el-button size="small" type="primary" @click="fetchWorkOrderLoad">
        Get Work-Order Load
    </el-button>
    <div style="display: flex: flex-direction: column; margin-top: 20px;">

        <el-table
            :data="workOrderData.work_order_load"
            style="width: 100%"
            :default-sort = "{prop: 'appointment_date', order: 'ascending'}"
>
          <el-table-column 
            prop="appointment_date"
            label="Promise Date" sortable>     
            <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.appointment_date_changed}}
                </span> 
            </template>       
          </el-table-column>
            
          <el-table-column 
            prop="delivery"
            label="Deliveries" align="center" sortable>  
              <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.delivery}}
                </span>                
              </template>          
          </el-table-column>

          <el-table-column 
            prop="trial"
            label="Trials" align="center" sortable>  
              <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.trial}}
                </span>                
              </template>          
          </el-table-column>
            
        </el-table>

    </div>
  </div>
</template>

<script>
export default {
    props: ['workOrderData'],
    methods: {
        fetchWorkOrderLoad() {
            this.$store.dispatch('workOrderLoad', 
            {
                sale_item_id: this.workOrderData.sale_item_id, 
                category_id: this.workOrderData.category_id,
                tailoring_item_id: this.workOrderData.tailoring_item_id,
                appointment_date: this.workOrderData.appointment_date
            })    
        }
    },
    mounted() {
        
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/DisplayWOLoad.vue